export const mojoNotificationFlag = '_hm_139_mojo_notification_enabled';
